;(function ($) {
	function init() {
		if ($('.shipper-db-prefix-modal').length) {
			//open modal
			$(window).on('load', function () {
				open_modal();
				$('.shipper-db-prefix-modal').find('.sui-tab-item.active input[name="migrate_dbprefix"]').click()
			});
			$('.shipper-db-prefix-modal .sui-dialog-close,' +
				' .shipper-db-prefix-modal .shipper-cancel').on('click', handle_preflight_cancel);
			$('.shipper-update-prefix').on('click', handle_update_prefix);
			$('.shipper-db-prefix-modal button[data-modal-close]').on('click', handle_preflight_cancel);
		}
	}

	function stop_prop(e) {
		if (e && e.preventDefault) e.preventDefault();
		if (e && e.stopPropagation) e.stopPropagation();
		return false;
	}

	/**
	 * Copy the code form preflight as the process much same
	 * @param e
	 * @returns {boolean}
	 */
	function handle_preflight_cancel(e) {
		$.post(ajaxurl, {action: 'shipper_preflight_cancel'}, function () {
			window.location.search = '?page=shipper-api';
		});
		return stop_prop(e);
	}

	/**
	 * Saving the prefix option to current migration
	 */
	function handle_update_prefix(e) {
		var option = $('input[name="migrate_dbprefix"]');

		option.each( function(key, element) {
			if ( $(element).is(':checked') ) {
				option = $(element).val();
			}
		})

		var value = $('input[name="migrate_dbprefix_value"]').val()

		$.post(ajaxurl, {
			action: 'shipper_dbprefix_update',
			option: option,
			value: value
		}, function (data) {
			if (data.success === true) {
				location.reload();
			} else {
				//show error
			}
		});
	}

	function open_modal( replace_modal ) {
		var replace_modal = replace_modal ? true : false;
		var modal_id = get_modal_id();
		var focus_after_closed = this;
		var focus_when_open = undefined;
		var has_overlay_mask = false;
		var modal = get_modal();

		SUI[ replace_modal ? 'replaceModal' : 'openModal' ]( modal_id, focus_after_closed, focus_when_open, has_overlay_mask )

		return modal;
	}

	function get_modal_id() {
		return 'shipper-db-prefix';
	}

	function get_modal() {
		return $( '#' + get_modal_id() );
	}

	$(init());
}(jQuery))